import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { MaterialRule } from 'src/app/models/MaterialRule.model';
import { Rule } from 'src/app/models/rule.model';


export interface RuleState extends EntityState<Rule> {
  finalProductId: number | null;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'rules' })
export class RuleStore extends EntityStore<RuleState, Rule> {
  constructor() {
    super({ finalProductId: null });
  }
}
